<div appFormControl class="sortcode">
  <input
    (input)="onSortCodeChange($event)"
    [attr.required]="required"
    [formControl]="control"
    [placeholder]="'XX-XX-XX'"
    appFormNumericInput
    class="sortcode__input text--center"
    inputmode="numeric"
    maxlength="8"
    type="text"
  />
  @if (control.touched && control.enabled) {
    <app-validity-icon
      [valid]="control.valid"
      class="sortcode__input-check-icon"
    />
  }
</div>
